import { Font, StyleSheet } from "@react-pdf/renderer";

Font.registerHyphenationCallback((word) => [word]);

const styles = StyleSheet.create({
  questionNumber: {
    fontWeight: 700,
    fontSize: 10,
  },
  textBold: {
    fontWeight: 700,
  },
  textItalic: {
    fontStyle: "italic",
    fontWeight: 400,
  },
  textItalicBold: {
    fontStyle: "italic",
    fontWeight: 700,
  },
  questionBody: {
    fontSize: 10,
    lineHeight: 1.5,
    paddingRight: 8,
  },
  answer: {
    fontWeight: 700,
    color: "red",
    textDecoration: "underline",
    textDecorationColor: "red",
  },
  openEndedAnswer: {
    fontWeight: 700,
    color: "red",
  },
  answerLabel: {
    fontWeight: 700,
    color: "red",
    marginBottom: 2,
  },
  answerContainer: {
    marginBottom: 8,
    padding: 4,
    borderLeft: "2px solid red",
    paddingLeft: 6,
  },
  explanation: {
    fontWeight: 700,
    color: "blue",
  },
  explanationLabel: {
    fontWeight: 700,
    color: "blue",
    marginBottom: 2,
  },
  explanationContainer: {
    marginBottom: 8,
    padding: 4,
    borderLeft: "2px solid blue",
    paddingLeft: 6,
  },
  questionContainerV: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 8,
  },
  questionContainerH: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingHorizontal: 8,
    paddingBottom: 8,
    width: "100%",
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingBottom: 8,
    marginBottom: 8,
  },
  questionImage: {
    width: "95%",
    height: "auto",
    marginBottom: 8,
    marginTop: 4,
  },
  questionWrapper: {
    marginBottom: 12,
    padding: 8,
  },
  trueFalseCheckbox: {
    width: 12,
    height: 12,
    borderRadius: 2,
    border: "1px solid black",
    backgroundColor: "white",
  },
  trueFalseOptionsContainer: {
    flexDirection: "row",
    marginTop: 8,
    gap: 16,
    marginLeft: 16,
  },
  trueFalseOptionContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  // Table styles
  tableContainer: {
    width: "100%",
    marginTop: 8,
    marginBottom: 8,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableHeaderRow: {
    flexDirection: "row",
  },
  tableHeaderCell: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000000",
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    paddingRight: 6,
    backgroundColor: "#bdbdbd",
  },
  tableCell: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000000",
    borderTopWidth: 0,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    paddingRight: 6,
  },
  tableCellText: {
    fontSize: 8,
    textAlign: "center",
    color: "#000000",
    margin: 0,
  },
  tableCellHeaderText: {
    fontSize: 8,
    fontWeight: "bold",
    textAlign: "center",
    color: "#000000",
    margin: 0,
  },
  // List styles
  listContainer: {
    marginRight: 16,
    marginLeft: 8,
    width: "100%",
  },
  listItem: {
    flexDirection: "row",
    marginBottom: 4,
    alignItems: "flex-start",
  },
  listNumber: {
    fontSize: 10,
    lineHeight: 1.5,
    minWidth: 16,
    fontWeight: 400,
  },
  listBullet: {
    fontSize: 10,
    lineHeight: 1.5,
    minWidth: 18,
  },
  listContent: {
    flex: 1,
  },
  // Paragraph styles
  paragraphContainer: {
    marginBottom: 8,
  },
});

export default styles;
